import { EnderecoPontoFisico } from './endereco-ponto-fisico';
import { StringValidacao } from './string';
import { Construtor } from './construtor';
import { RegiaoCliente } from './regiao-cliente';
import { Usuario } from './usuario';
import { TipoPontoFisico } from './tipo-ponto-fisico';
import { AreaCliente } from './area-cliente';

export class PontoFisico implements Construtor<PontoFisico> {

  public idPontoFisico: number;
  public nomePontoFisico: string;
  public cnpj: string;
  public usuario: Usuario;
  public enderecoPontoFisico: EnderecoPontoFisico;
  public idCliente: number;
  public pontoFisicoFranqueado: boolean;
  public regiaoCliente: RegiaoCliente;
  public tipoPontoFisico: TipoPontoFisico;
  public areaCliente: AreaCliente;
  public datasAgenda: Date[];
  public foto: string;
  public selecionado: boolean;
  public alterado: boolean;

  constructor(object?: any) {
    this.usuario = new Usuario();
    this.regiaoCliente = new RegiaoCliente();
    this.tipoPontoFisico = new TipoPontoFisico();
    this.areaCliente = new AreaCliente();
    this.datasAgenda = new Array<Date>();
    this.enderecoPontoFisico = new EnderecoPontoFisico();
    this.pontoFisicoFranqueado = false;
    if (object !== undefined) {
      if (object instanceof PontoFisico) {
        this.copyObject(object);
      } else if (object instanceof Usuario) {
        this.usuario = new Usuario(object);
      } else if (object instanceof RegiaoCliente) {
        this.regiaoCliente = new RegiaoCliente(object);
      } else if (object instanceof TipoPontoFisico) {
        this.tipoPontoFisico = new TipoPontoFisico(object);
      } else if (object instanceof AreaCliente) {
        this.areaCliente = new AreaCliente(object);
      } else {
        this.parseFromJson(object);
      }

      if (!this.modeloCompleto()) {
        return null;
      }
    }
    return this;
  }

  get obterIdPontoFisico(): number {
    return this.idPontoFisico;
  }

  set IdPontoFisico(id: number) {
    this.idPontoFisico = id;
  }

  get obterNomePontoFisico(): string {
    return this.nomePontoFisico.slice(0);
  }

  set NomePontoFisico(nomePontoFisico: string) {
    this.nomePontoFisico = StringValidacao.copiarStringValida(nomePontoFisico);
  }

  get obterCnpj(): string {
    return this.cnpj.slice(0);
  }

  set Cnpj(cnpj: any) {
    this.cnpj = StringValidacao.copiarStringValida(cnpj);
  }

  get obterUsuario(): Usuario {
    return this.usuario;
  }

  set Usuario(usuario: Usuario) {
    this.usuario = usuario;
  }

  set EnderecoPontoFisico(enderecoPontoFisico: any) {
    if (enderecoPontoFisico !== null && enderecoPontoFisico !== undefined) {
      this.enderecoPontoFisico = new EnderecoPontoFisico(enderecoPontoFisico);
    } else {
      this.enderecoPontoFisico = undefined;
    }
  }

  get obterEnderecoPontoFisico(): EnderecoPontoFisico {
    return this.enderecoPontoFisico;
  }

  set PontoFisicoFranqueado(pontoFisicoFranqueado: any) {
    this.pontoFisicoFranqueado = pontoFisicoFranqueado;
  }

  get obterPontoFisicoFranqueado(): boolean {
    return this.pontoFisicoFranqueado;
  }

  set IdCliente(idCliente: any) {
    this.idCliente = idCliente;
  }

  get obterIdCliente(): number {
    return this.idCliente;
  }

  copyObject(pontoFisico: PontoFisico): void {
    this.idPontoFisico = pontoFisico.obterIdPontoFisico;
    this.nomePontoFisico = pontoFisico.obterNomePontoFisico;
    this.cnpj = pontoFisico.obterCnpj;
    this.usuario = pontoFisico.obterUsuario;
    this.pontoFisicoFranqueado = pontoFisico.obterPontoFisicoFranqueado;
    this.enderecoPontoFisico = pontoFisico.enderecoPontoFisico;
    this.IdCliente = pontoFisico.obterIdCliente;
    this.regiaoCliente = pontoFisico.regiaoCliente;
    this.tipoPontoFisico = pontoFisico.tipoPontoFisico;
    this.foto = pontoFisico.foto;
    this.datasAgenda = pontoFisico.datasAgenda;
    this.areaCliente = pontoFisico.areaCliente;
  }

  parseFromJson(pontoFisico: any): void {
    this.IdPontoFisico = pontoFisico.idPontoFisico;
    this.NomePontoFisico = pontoFisico.nomePontoFisico;
    this.Cnpj = pontoFisico.cnpj;
    this.usuario = pontoFisico.usuario;
    this.PontoFisicoFranqueado = pontoFisico.pontoFisicoFranqueado;
    this.enderecoPontoFisico = pontoFisico.enderecoPontoFisico;
    this.IdCliente = pontoFisico.idCliente;
    this.regiaoCliente = pontoFisico.regiaoCliente;
    this.tipoPontoFisico = pontoFisico.tipoPontoFisico;
    this.foto = pontoFisico.foto;
    this.datasAgenda = pontoFisico.datasAgenda;
    this.areaCliente = pontoFisico.areaCliente;
  }

  modeloCompleto(): boolean {
    return this.nomePontoFisico !== undefined &&
      this.cnpj !== undefined &&
      this.usuario !== undefined;
  }

  getNewInstance(object?: any): PontoFisico {
    return new PontoFisico(object);
  }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/ponto-fisico.ts